import { Component } from '@theme/component';

/**
 * The footer's "Cookie preferences" link: reopens the preferences of Shopify's cookie banner, so visitors can change
 * or withdraw their consent. `window.privacyBanner` comes from Shopify's async privacy-banner.js, which can run after
 * this module and doesn't load without the banner, so the link stays hidden until the banner is there.
 *
 * @extends {Component}
 */
class CookiePreferencesComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    // Async scripts run before the load event, so the banner is there by then or not at all.
    if (!this.#reveal() && document.readyState !== 'complete') {
      window.addEventListener('load', this.#reveal, { once: true });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('load', this.#reveal);
  }

  open() {
    window.privacyBanner?.showPreferences();
  }

  #reveal = () => {
    if (!window.privacyBanner) return false;

    this.hidden = false;
    return true;
  };
}

if (!customElements.get('cookie-preferences-component')) {
  customElements.define('cookie-preferences-component', CookiePreferencesComponent);
}
